export { DeleteProductsModal } from './ui/DeleteProductsModal.main';
